import { render, staticRenderFns } from "./OrbitCountdown.vue?vue&type=template&id=99c0065e&scoped=true"
import script from "./OrbitCountdown.vue?vue&type=script&lang=ts"
export * from "./OrbitCountdown.vue?vue&type=script&lang=ts"
import style0 from "./OrbitCountdown.vue?vue&type=style&index=0&id=99c0065e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99c0065e",
  null
  
)

export default component.exports